
class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
  }

  connectedCallback() {
    const carousel = this.querySelector('.cart-upsell__products');
    const prevArrow = this.querySelector('.cart-upsell__arrow--prev');
    const nextArrow = this.querySelector('.cart-upsell__arrow--next');
    
    if (carousel && prevArrow && nextArrow) {
      const products = carousel.querySelectorAll('.cart-upsell__product');
      const totalProducts = products.length;
      
      const updateArrows = () => {
        prevArrow.disabled = this.currentIndex === 0;
        nextArrow.disabled = this.currentIndex === totalProducts - 1;
      };
      
      const scrollToProduct = (index) => {
        const itemWidth = products[0].offsetWidth;
        carousel.scrollTo({
          left: itemWidth * index,
          behavior: 'smooth'
        });
        this.currentIndex = index;
        updateArrows();
      };
      
      prevArrow.addEventListener('click', () => {
        if (this.currentIndex > 0) {
          scrollToProduct(this.currentIndex - 1);
        }
      });
      
      nextArrow.addEventListener('click', () => {
        if (this.currentIndex < totalProducts - 1) {
          scrollToProduct(this.currentIndex + 1);
        }
      });
      
      carousel.addEventListener('scroll', () => {
        const scrollLeft = carousel.scrollLeft;
        const itemWidth = products[0].offsetWidth;
        this.currentIndex = Math.round(scrollLeft / itemWidth);
        updateArrows();
      });
      
      updateArrows();
    }
  }
}
customElements.define('cart-upsell', CartUpsell);
